import { render, staticRenderFns } from "./ClinicVideosItem.vue?vue&type=template&id=c82a9d1e&"
import script from "./ClinicVideosItem.vue?vue&type=script&lang=js&"
export * from "./ClinicVideosItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports